module.exports = __webpack_public_path__ + "static/img/login-bg6.32b985b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login-bg6.jpg
// module id = 1251
// module chunks = 169